import styled from "styled-components";
import {LiveCasinoFilterButtonIconDefaultBox} from "./live-casino-filter-button-icon.default.box";

export const LiveCasinoFilterIconSIBox = styled(LiveCasinoFilterButtonIconDefaultBox)`
    color: ${({theme}) => theme.colors.textLight};
`;